import { authHeaders, handleUnauthorized } from "@/lib/pin";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function streamReport(payload, handlers) {
  return streamSse(`${API}/report`, payload, handlers);
}

export async function streamMethod(payload, handlers) {
  return streamSse(`${API}/metodo`, payload, handlers);
}


async function streamSse(url, payload, { onToken, onDone, onError, onStatus, signal }) {
  try {
    const res = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", ...authHeaders() },
      body: JSON.stringify(payload),
      signal,
    });
    handleUnauthorized(res);
    if (!res.ok || !res.body) throw new Error(`Errore del server (${res.status})`);
    const reader = res.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";
    while (true) {
      const { value, done } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      const parts = buffer.split("\n\n");
      buffer = parts.pop();
      for (const part of parts) {
        const line = part.trim();
        if (!line.startsWith("data:")) continue;
        const data = line.slice(5).trim();
        if (data === "[DONE]") {
          onDone();
          return;
        }
        const obj = JSON.parse(data);
        if (obj.error) throw new Error(obj.error);
        if (obj.t) onToken(obj.t);
        if (obj.s && onStatus) onStatus(obj.s);
      }
    }
    onDone();
  } catch (e) {
    if (e.name !== "AbortError") onError(e);
  }
}
